import { User } from "@/models/user";

export interface subscription {
  id: number;
  name: string;
  trialPlanDescription: string;
  trialDescription: string;
  amount: number;
  amountShow: number;
  month: number;
  isTrial: boolean;
  trialDay: number;
  isAutoActive: boolean;
  title: string;
  priceUSDShow: string;
  priceVNDShow: string;
  priceIDOShow: string;
  description: string;
  isPopular: boolean;
  saving: number;
  isHidden: boolean;
  options: number[];
  content: Content[];
  status: number;
  parentLanguage: string;
  language: string;
  userSubscriptions: User[];
  languages?: subscription[];
  createdAt: Date;
  updatedAt: Date;
  deletedAt: Date;
  prevSubscriptionId: number;
  preSubscription: subscription;
}
export interface Content {
  name: string;
  isComplete: boolean;
  isHidden: boolean;
  isHiddenTrial: boolean;
}
export interface StatusSubscription {
  id: number;
  name: string;
}
export const statusSubscription: StatusSubscription[] = [
  {
    id: 1,
    name: "Active",
  },
  {
    id: 2,
    name: "Inactive",
  },
];

export interface OptionSubscription {
  id: number;
  name: string;
}
export enum OPTIONS_SUBSCRIPTION {
  PREMIUM = 1,
  INTERACTIVE,
  AI,
  EMBED,
}
export const optionRoleSubscription: OptionSubscription[] = [
  {
    id: OPTIONS_SUBSCRIPTION.PREMIUM,
    name: "View report premium",
  },
  {
    id: OPTIONS_SUBSCRIPTION.INTERACTIVE,
    name: "View report interactive",
  },
  {
    id: OPTIONS_SUBSCRIPTION.AI,
    name: "Have AI",
  },
  {
    id: OPTIONS_SUBSCRIPTION.EMBED,
    name: "View embedded report",
  },
];

export const optionTrialSubscription: OptionSubscription[] = [
  {
    id: 1,
    name: "Trial",
  },
  {
    id: 2,
    name: "Paid",
  },
];

export enum STATUS_SUBSCRIPTION {
  ACTIVE = 1,
  INACTIVE,
}
